

















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { RgCategoryFilter, DateRangeFilter, MultiSelect, ArchiveFilter, TagFilter, TextInput } from '../components/filters';

@Component({
    components: {
        RgCategoryFilter,
        DateRangeFilter,
        MultiSelect,
        ArchiveFilter,
        TagFilter,
        TextInput
    }
})
export default class CalibrationSelector extends Vue {
    // 本地状态
    calibrationFilter: any = {
        ctiNameList: [],
        archiveIds: [],
        labels: [],
        calibrationStatus: [],
        createdTimeRange: [],
        ticketId: '',
        taskId: ''
    };

    // 状态选项 UNCALIBRATED,PASSED,FAILED;
    calibrationStatusOptions: { id: string; displayName: string }[] = [
        { id: 'UNCALIBRATED', displayName: '未校准' },
        { id: 'FAILED', displayName: '不通过' }
    ];

    @Prop({ type: Number, default: 0 })
    rgId!: number;

    /**
     * 构建查询参数
     */
    buildQueryParams() {
        return {
            rgId: this.rgId,
            ...this.calibrationFilter
        };
    }

    /**
     * 触发变更事件
     */
    emitChange() {
        this.$emit('filter-change', this.buildQueryParams());
    }

    /**
     * 处理搜索
     */
    handleSearch() {
        this.emitChange();
    }

    created() {
        this.initFilter();
    }

    initFilter() {
        const url = new URLSearchParams(window.location.search);
        const params = {
            taskId: url.get('taskId') || ''
        };
        this.calibrationFilter = params;
    }

    @Watch('rgId')
    onRgIdChange() {
        this.emitChange();
    }
}
